/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

      if (window.PXUTheme.jsCart) {
        window.PXUTheme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        $('[data-cart-announcement]').each(function() {
          if (options.item_count > 0) {
            $(this).removeClass('is-hidden');
          } else {
            $(this).addClass('is-hidden');
          }
        });

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');

    if (this.recipientForm) {
      this.recipientForm.classList.remove('recipient-form--has-errors');
    }

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {
          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              window.PXUTheme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          window.PXUTheme.jsAjaxCart.showDrawer();
          window.PXUTheme.jsAjaxCart.updateView();
          // setTimeout(function() { $('[data-cart-announcement]').removeClass('is-hidden'); }, 500);

          if (window.PXUTheme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: XMLHttpRequest => {
          const response = eval('(' + XMLHttpRequest.responseText + ')');

          $('.warning').remove();

          let cartWarning;

          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
          }

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {

    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
        $('[data-cart-announcement]').removeClass('is-hidden');
        $('[data-cart-progress-bar]').removeClass('is-hidden');

        // Update progress bar
        fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const threshold = window.cartSettings ? window.cartSettings.freeShippingThreshold : 23000;
          const total = cart.total_price;
          const remaining = threshold - total;
          const percentage = Math.min((total / threshold) * 100, 100);

          $('[data-cart-progress-fill]').css('width', percentage + '%');
          $('[data-cart-progress-fill]').attr('aria-valuenow', Math.round(percentage));

          if (remaining <= 0) {
            $('[data-cart-progress-label]').html("🎉 Congrats! You've unlocked <b>FREE SHIPPING!</b>");
          } else {
            const remainingMoney = (remaining / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            $('[data-cart-progress-label]').html('You are <b>' + remainingMoney + '</b> away from <b>FREE SHIPPING</b>!');
          }
        });

        // Load YMAL recommendations
        window.PXUTheme.jsAjaxCart.loadRecommendations();

      } else {
        $('.ajax-cart__list').empty();
        $('.ajax-cart__savings .money').text('$0.00'); 
        $('.ajax-cart__savings').hide();
        $('.ajax-cart__subtotal .money').text('$0.00');
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
        $('[data-cart-announcement]').addClass('is-hidden');
        $('[data-cart-progress-bar]').addClass('is-hidden');
        $('#ajax-cart-ymal').empty();
      }

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  loadRecommendations: function () {

    // Get all current cart item keys to filter them out of recommendations
    const cartItems = document.querySelectorAll('.ajax-cart__product[data-product-id]');
    const cartProductIds = Array.from(cartItems).map(el => String(el.dataset.productId));

    // Use the first cart item as the seed product for recommendations
    const firstItem = document.querySelector('.ajax-cart__product[data-cart-item]');
    if (!firstItem) {
      $('#ajax-cart-ymal').empty();
      return;
    }

    // Extract product ID from the item key (format: productId:variantId)
    const productId = firstItem.dataset.productId || firstItem.dataset.cartItem.split(':')[0];

    fetch(`/recommendations/products.json?product_id=${productId}&limit=6&intent=related`)
      .then(res => res.json())
      .then(data => {

        // Filter out products already in cart
        const filtered = data.products.filter(p => {
          return !cartProductIds.includes(String(p.id));
        }).slice(0, 3);

        if (filtered.length === 0) {
          $('#ajax-cart-ymal').empty();
          return;
        }

        let html = '<div class="ajax-cart__ymal-title">YOU MAY ALSO LIKE</div><div class="ajax-cart__ymal-list">';

        filtered.forEach(product => {
          const variant = product.variants[0];
          const image = product.images[0] ? product.images[0].src : '';
          const price = (variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          const compareAtPrice = variant.compare_at_price
            ? `<span class="ajax-cart__ymal-compare-price">${(variant.compare_at_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</span>`
            : '';

          html += `
            <div class="ajax-cart__ymal-item">
              <a href="/products/${product.handle}" class="ajax-cart__ymal-image-link">
                <img src="${image}" alt="${product.title}" />
              </a>
              <div class="ajax-cart__ymal-info">
                <p class="ajax-cart__ymal-name">${product.title}</p>
                <p class="ajax-cart__ymal-price">${price} ${compareAtPrice}</p>
              </div>
              <button
                class="ajax-cart__ymal-btn button"
                data-variant-id="${variant.id}"
                data-product-id="${product.id}"
              >ADD</button>
            </div>
          `;
        });

        html += '</div>';
        $('#ajax-cart-ymal').html(html);

        // Bind ADD buttons — uses fetch directly to avoid form dependency
        $('#ajax-cart-ymal').find('.ajax-cart__ymal-btn').on('click', function () {
          const variantId = $(this).data('variant-id');
          const $btn = $(this);

          $btn.text('Adding...').prop('disabled', true);

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
          .then(res => res.json())
          .then(() => {
            window.PXUTheme.jsAjaxCart.updateView();
          })
          .catch(() => {
            $btn.text('ADD').prop('disabled', false);
          });
        });

      })
      .catch(() => {
        $('#ajax-cart-ymal').empty();
      });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;